(function () {

    'use strict';
    angular.module('app')
        .controller('resetAuthenticatorController', ['$scope', '$location', '$routeParams', 'accountsService', resetAuthenticatorController]
            );

    function resetAuthenticatorController($scope, $location, $routeParams, accountsService) {
        $scope.model = {};

        $scope.init = function () {

            accountsService.resetAuthenticator($routeParams.t)
                .then(function () {
                    $scope.model.complete = true;
                    $scope.model.success = true;
                },
                    function (response) {
                        $scope.model.working = false;
                        $scope.model.error = response.errors[0].message;
                        $scope.model.complete = true;
                        $scope.model.success = false;
                    });

        };

        $scope.redirectToLogin = function () {
            if ($routeParams.ct != undefined) {
                $location.url('/login?ct=' + window.encodeURIComponent($routeParams.ct));
            } else {
                $location.url('/login');
            }
        };
    }
})();